import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { ThemeManager } from "@/context/ThemeContext";
import KopyHome from "@/pages/KopyHome";
import Home from "@/pages/Home";
import Custom from "@/pages/Custom";
import RollBuilder from "@/pages/RollBuilder";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import FAQ from "@/pages/FAQ";
import Admin from "@/pages/Admin";
import SignsHome from "@/pages/SignsHome";
import Corflute from "@/pages/Corflute";
import Foamboard from "@/pages/Foamboard";
import Pvc from "@/pages/Pvc";
import PullUpBuilder from "@/pages/PullUpBuilder";
import CoasterBuilder from "@/pages/CoasterBuilder";
import FixedBuilder from "@/pages/FixedBuilder";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ThemeManager />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<KopyHome />} />
          <Route path="/stickers" element={<Home />} />
          <Route path="/shop" element={<Navigate to="/stickers" replace />} />
          <Route path="/product/:slug" element={<Navigate to="/stickers" replace />} />
          <Route path="/custom" element={<Navigate to="/die-cut-stickers" replace />} />
          <Route path="/die-cut-stickers" element={<Custom key="diecut" mode="diecut" />} />
          <Route path="/stickers-on-rolls" element={<RollBuilder />} />
          <Route path="/stickers-on-sheets" element={<Custom key="sheets" mode="sheets" />} />
          <Route path="/signs" element={<SignsHome />} />
          <Route path="/corflute" element={<Corflute />} />
          <Route path="/foamboard" element={<Foamboard />} />
          <Route path="/pvc" element={<Pvc />} />
          <Route path="/pull-up-banners" element={<PullUpBuilder />} />
          <Route path="/coasters" element={<CoasterBuilder />} />
          <Route path="/flags" element={<FixedBuilder key="flag" product="flag" />} />
          <Route path="/a-frames" element={<FixedBuilder key="aframe" product="aframe" />} />
          <Route path="/media-walls" element={<FixedBuilder key="mediawall" product="mediawall" />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/about" element={<About />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order/:orderNumber" element={<OrderConfirmation />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </CartProvider>
  );
}

export default App;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
